// src/services/mailApi.js
import { apiClient } from "../utils/apiClient";

// Backend route varsayımları (controller attribute'ların farklıysa sadece burayı güncelle):
//  - GET/PUT/POST: /api/mail/settings
//  - POST: /api/mail/settings/test
//  - CRUD: /api/mail/subscriptions
//  - POST: /api/mail/subscriptions/{id}/run-now
//  - GET: /api/mail/dispatch-logs

function toQuery(params = {}) {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    usp.append(k, String(v));
  });
  const qs = usp.toString();
  return qs ? `?${qs}` : "";
}

export const mailApi = {
  // ===== Settings =====
  async getSettings() {
    return await apiClient("mail/settings", { method: "GET" });
  },

  async upsertSettings(payload) {
    return await apiClient("mail/settings", { method: "PUT", body: payload });
  },

  async testSettings(payload) {
  const to =
    payload?.toEmail ||
    payload?.ToEmail ||
    payload?.to ||
    payload?.To ||
    payload?.email ||
    payload?.Email ||
    "";

  const subject = payload?.subject || payload?.Subject || "XPass PDKS Test Mail";
  const bodyText =
    payload?.body ||
    payload?.Body ||
    payload?.message ||
    payload?.Message ||
    "Mail ayarları test edildi.";

  // ✅ Hem query hem body: backend ister FromQuery ister FromBody olsun çalışsın
  const qs = toQuery({
    toEmail: to,
    ToEmail: to,
    to: to,
    email: to,
  });

  const tolerantBody = {
    toEmail: to,
    ToEmail: to,
    to: to,
    To: to,
    email: to,
    Email: to,

    subject,
    Subject: subject,

    body: bodyText,
    Body: bodyText,

    message: bodyText,
    Message: bodyText,
  };

  return await apiClient(`mail/settings/test${qs}`, { method: "POST", body: tolerantBody });
},

  // ===== Subscriptions =====
  async getDirectory(params = {}) {
    const qs = toQuery(params);
    return await apiClient(`mail/subscriptions/directory${qs}`, { method: "GET" });
  },

  async getDirectoryBulkEmails(params = {}) {
    const qs = toQuery(params);
    return await apiClient(`mail/subscriptions/directory/bulk-emails${qs}`, { method: "GET" });
  },

  async listSubscriptions(params = {}) {
    // Not: Backend tarafında page/pageSize yok; query param zorunlu değil.
    // İstersen (ileride) isEnabled gibi filtreler eklenecekse burada kullanırız.
    // Şimdilik parametre gelirse bile sadece desteklediğimiz alanları geçir.
    const safeParams = {};
    if (params?.isEnabled !== undefined && params?.isEnabled !== null) safeParams.isEnabled = params.isEnabled;
    const qs = toQuery(safeParams);
    return await apiClient(`mail/subscriptions${qs}`, { method: "GET" });
  },

  async createSubscription(payload) {
    return await apiClient("mail/subscriptions", { method: "POST", body: payload });
  },

  async updateSubscription(id, payload) {
    return await apiClient(`mail/subscriptions/${id}`, { method: "PUT", body: payload });
  },

  async deleteSubscription(id) {
    return await apiClient(`mail/subscriptions/${id}`, { method: "DELETE" });
  },

  async runNow(id) {
    return await apiClient(`mail/subscriptions/${id}/run-now`, { method: "POST" });
  },

    // ===== System (Firm-level scheduler enable/disable) =====
    async getSystemStatus() {
        return await apiClient("mail/system/status", { method: "GET" });
    },
    async enableSystem(payload) {
        return await apiClient("mail/system/enable", { method: "POST", body: payload });
    },
    async disableSystem() {
        return await apiClient("mail/system/disable", { method: "POST" });
    },

  // ===== Logs =====
  async listDispatchLogs(params = {}) {
    const safeParams = {};
    if (params?.subscriptionId !== undefined && params?.subscriptionId !== null && params?.subscriptionId !== "") {
      safeParams.subscriptionId = params.subscriptionId;
    }
    if (params?.status) safeParams.status = params.status;
    if (params?.search) safeParams.search = params.search;
    if (params?.startDate) safeParams.startDate = params.startDate;
    if (params?.endDate) safeParams.endDate = params.endDate;
    if (params?.take) safeParams.take = params.take;
    const qs = toQuery(safeParams);
    return await apiClient(`mail/dispatch-logs${qs}`, { method: "GET" });
  },
};

export default mailApi;
